import api from '@/lib/axios';

function unwrap<T>(r: { data: { data?: T } | T }): T {
  const body: any = r.data;
  return (body?.data ?? body) as T;
}

export interface OrgSchoolOption {
  id: string;
  name: string;
}

export interface OrgStudentOption {
  id: string;
  admissionNo: string;
  name: string | null;
}

export interface GuardianRow {
  linkId: string;
  guardianId: string;
  firstName: string | null;
  lastName: string | null;
  mobile: string | null;
  email: string | null;
  gender: string | null;
  username: string;
  image: string | null;
  status: number;
  linkedAt: string;
}

export interface AddGuardianData {
  schoolId: string;
  studentId: string;
  firstName: string;
  lastName?: string;
  email?: string;
  mobile: string;
  gender: 'male' | 'female';
  username?: string;
  image?: string;
}

export interface UpdateGuardianData {
  schoolId: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  mobile?: string;
  gender?: 'male' | 'female';
  username?: string;
  image?: string;
}

export const OrgGuardiansApi = {
  schools: async (): Promise<OrgSchoolOption[]> => unwrap(await api.get('/org/guardians/schools')),

  students: async (schoolId: string, search?: string): Promise<OrgStudentOption[]> =>
    unwrap(await api.get(`/org/guardians/schools/${schoolId}/students`, { params: search ? { search } : undefined })),

  list: async (schoolId: string, studentId: string): Promise<GuardianRow[]> =>
    unwrap(await api.get('/org/guardians', { params: { schoolId, studentId } })),

  add: async (data: AddGuardianData): Promise<GuardianRow> => unwrap(await api.post('/org/guardians', data)),

  update: async (guardianId: string, data: UpdateGuardianData): Promise<GuardianRow> =>
    unwrap(await api.patch(`/org/guardians/${guardianId}`, data)),

  resetPassword: async (guardianId: string, schoolId: string, password: string): Promise<{ reset: true }> =>
    unwrap(await api.post(`/org/guardians/${guardianId}/reset-password`, { schoolId, password })),

  removeLink: async (linkId: string, schoolId: string): Promise<{ deleted: true; id: string }> =>
    unwrap(await api.delete(`/org/guardians/links/${linkId}`, { params: { schoolId } })),
};
